import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge.js';
import type { BadgeTone } from '@/components/ui/badge.js';

export type PillStatus =
  | 'pending'
  | 'approved'
  | 'paid'
  | 'rejected'
  | 'cancelled'
  | 'completed'
  | 'failed';

const STATUS_TONE: Record<PillStatus, BadgeTone> = {
  pending:   'warning',
  approved:  'info',
  paid:      'success',
  rejected:  'danger',
  cancelled: 'muted',
  completed: 'success',
  failed:    'danger',
};

interface StatusPillProps {
  status: string;
}

export function StatusPill({ status }: StatusPillProps) {
  const { t } = useTranslation('common');
  const tone = STATUS_TONE[status as PillStatus];
  if (tone) {
    return <Badge tone={tone}>{t(`status.${status}`)}</Badge>;
  }
  return <Badge tone="muted">{status}</Badge>;
}
